import {
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Typography,
  Dialog,
  Button,
} from '@ui/components';
import { cdnOnboardingTemplatePath, getCdnGuidelinesPath } from '@shared/utils';
import { FileUploader, FieldsList } from '@pages/onboarding/containers';
import { useTranslation } from 'react-i18next';
import { PropsWithChildren, FC } from 'react';

interface OnboardingImportModalProps extends PropsWithChildren {
  open?: boolean;
  setOpen?: (open: boolean) => void;
}

export const OnboardingImportModal: FC<OnboardingImportModalProps> = ({
  children,
  setOpen,
  open,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>{children}</DialogTrigger>

      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>{t('ONBOARDING.IMPORT_MODAL.TITLE')}</DialogTitle>
        </DialogHeader>

        <section className="p-4 space-y-6">
          <Typography variant="paragraphBasicBook" element="p">
            {t('ONBOARDING.IMPORT_MODAL.DESCRIPTION_1')}
          </Typography>

          <Typography variant="paragraphBasicBook" element="p">
            {t('ONBOARDING.IMPORT_MODAL.DESCRIPTION_2')}
          </Typography>

          <div className="flex items-center gap-4">
            <Button variant="secondary" asChild>
              <a href={cdnOnboardingTemplatePath} rel="noreferrer" target="_blank">
                {t('ONBOARDING.IMPORT_MODAL.DOWNLOAD_CSV_TEMPLATE')}
              </a>
            </Button>

            <Button variant="link" asChild>
              <a href={getCdnGuidelinesPath()} rel="noreferrer" target="_blank">
                {t('ONBOARDING.IMPORT_MODAL.SHOW_PDF_INSTRUCTIONS')}
              </a>
            </Button>
          </div>

          <Typography variant="paragraphBasicBook" element="p">
            {t('ONBOARDING.IMPORT_MODAL.FIELDS_LIST')}
          </Typography>

          <FieldsList />

          <FileUploader onCancel={() => setOpen?.(false)} className="mt-8" />
        </section>
      </DialogContent>
    </Dialog>
  );
};
